export default __webpack_public_path__ + "static/gorgeous-loading-79dfd1211092e7e1b8870642391f85b9.gif";